import { useApiQuery } from '@/hooks/useApiQuery';
import { apiPost, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { schedulerKeys } from '@/lib/queryKeys';

/** GAP-02 (Delta 2) — one tech's skill-qualification for the whole selection. */
export interface QualifiedTechnician {
  technicianId: string;
  qualified: boolean;
  /** Skills/levels the tech lacks (e.g. "HVAC L3") — the disabled-option reason. */
  missing?: string[];
}

/**
 * GAP-02 (Delta 2) — which technicians are skill-qualified to LEAD every one of
 * the selected appointments. Recomputes whenever the selection changes so the
 * "Reassign to" picker can list qualified techs first and disable the rest with
 * their missing-skill reason. Territory is soft (a warning), never disqualifies.
 */
export function useQualifiedTechnicians(appointmentIds: string[]) {
  const sortedIds = [...appointmentIds].sort();
  return useApiQuery<QualifiedTechnician[]>({
    queryKey: [...schedulerKeys.technicians(), 'qualified', sortedIds],
    queryFn: () =>
      apiPost<QualifiedTechnician[]>(operationsClient, jobEndpoints.qualifiedTechnicians(), {
        appointmentIds: sortedIds,
      }),
    enabled: sortedIds.length > 0,
    showErrorToast: false,
  });
}
